module.exports = __webpack_public_path__ + "img/delete.c2916a14.svg";